module.exports = __webpack_public_path__ + "img/done.79e4f432.png";